<template lang='pug'>
i.svg-icon.svg-icon-voice
  svg(
    :fill='color'
    :width='`${size}px`'
    :height='`${size}px`'
    viewBox='0 0 100 100')

    path(d='M49.61,50.69c0,8.73,0,17.46,0,26.19c0,2.34-1.31,4.09-3.44,4.57c-1.72,0.39-3.15-0.19-4.38-1.43 c-3.92-3.94-7.86-7.87-11.79-11.8c-1.24-1.24-2.51-2.47-3.72-3.74c-0.44-0.46-0.9-0.61-1.51-0.6c-3.37,0.03-6.74,0.02-10.11,0.01 c-3.05,0-4.85-1.79-4.86-4.82c-0.01-5.65-0.01-11.3,0-16.94c0.01-3.03,1.81-4.81,4.86-4.82c3.37,0,6.74-0.02,10.11,0.01 c0.62,0.01,1.06-0.16,1.51-0.61c5.16-5.19,10.34-10.36,15.52-15.54c1.67-1.66,3.76-2.04,5.58-0.97c1.55,0.91,2.24,2.32,2.24,4.11 c-0.01,6.11,0,12.22,0,18.33C49.61,45.33,49.61,48.01,49.61,50.69z')

    path(d='M89.41,53.55c-0.15,9.11-4.35,19.49-12.73,28.14c-1.27,1.31-2.82,1.77-4.58,1.24c-1.69-0.51-2.71-1.71-3.05-3.43 c-0.31-1.6,0.25-2.94,1.37-4.08c2.67-2.71,4.82-5.78,6.53-9.19c6.52-13.04,4.08-29.35-6-39.88c-0.92-0.97-1.84-1.92-1.99-3.34 c-0.21-1.97,0.74-3.73,2.45-4.56c1.71-0.82,3.7-0.49,5.1,0.9c3.71,3.7,6.66,7.93,8.85,12.69C88.08,37.94,89.45,44.13,89.41,53.55z')
    
    path(d='M71.77,50.08c-0.16,7.76-2.66,13.99-7.69,19.17c-1.3,1.34-2.89,1.78-4.66,1.18c-1.77-0.6-2.78-1.91-2.99-3.77 c-0.16-1.43,0.39-2.64,1.39-3.66c2.72-2.79,4.4-6.12,4.89-9.98c0.72-5.66-0.92-10.59-4.83-14.74c-1.07-1.14-1.67-2.41-1.41-3.98 c0.28-1.75,1.29-2.95,2.94-3.52c1.7-0.58,3.27-0.22,4.54,1.06c4.03,4.04,6.51,8.88,7.43,14.51C71.61,47.76,71.68,49.21,71.77,50.08z')

</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },
}

</script>